import { handleActions, Action } from 'redux-actions';
import {
  fetchFoldersSuccess,
  FetchFoldersSuccessActionPayload,
} from '../actions/folders';

const defaultState = {
  galleryFolders: { ids: [] },
  collectionFolders: { ids: [] },
};

const handleFetchFoldersSuccess = (
  state,
  { payload }: Action<FetchFoldersSuccessActionPayload>
) => {
  const { ids, gallectionType } = payload!;
  return { ...state, [`${gallectionType}Folders`]: { ids } };
};

const reducer = handleActions(
  {
    [fetchFoldersSuccess.toString()]: handleFetchFoldersSuccess,
  },
  defaultState
);

export default reducer;
